import { LandingLayout } from "@web/components/LandingPage/LandingLayout"
import LandingPage from "@web/components/LandingPage/LandingPage/LandingPage"

const MainPage = () => {
  return (
    <LandingLayout>
      <LandingPage />
    </LandingLayout>
  )
}

export default MainPage
